<script lang="ts">
  import logo from "../../assets/icons/progress_logo.svg";
  import gift from "../../assets/icons/progress_gift.svg";
  import Progress from "./Progress.svelte";
  import { getStepNumberAndTotal } from "../../lib/stores/pageProgress";

  $: stepNumber = $getStepNumberAndTotal?.stepNumber;
  $: totalSteps = $getStepNumberAndTotal?.totalSteps;
  $: progress = stepNumber && totalSteps ? (stepNumber / totalSteps) * 100 : 0;
</script>

{#if stepNumber}
  <div class="fixed flex top-12 lg:hidden justify-between items-center w-full px-4 pb-2 gap-4 bg-white z-10">
    <img src={logo} alt="logo" />
    <Progress {progress}></Progress>
    <img src={gift} alt="gift" />
  </div>
{/if}
